var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { Component, Fragment } from "react";
import { ShadowCard } from "@irati/ui/src/Layout";
import HR from "@irati/ui/src/Layout/Hr";
import { DealListSort, DealsListType, DealStatus } from "@irati/types";
import Flex from "@irati/ui/src/Flex";
import DealList, { getDealList, updateDealList, removeFromDealList } from "@irati/deals/apollo/query/DealList";
import teamService from "@irati/identity/services/teams";
import { Label2 } from "@irati/ui/src/Labels";
import authentication from "@irati/auth";
import { IconTooltip } from "@irati/ui/src/Tooltip";
import FormattedMessage from "@irati/utils/lang";
import CompanyBenefitsActions from "../CompanyBenefitsActions";
import CompanyBenefitsPopup from "../CompanyBenefits/Popup";
import { Div, BenefitHeader } from "./styled";
import LoadMore from "./LoadMore";
import NoCompanyBenefits from "./NoCompanyBenefits";
import HasBenefitsHeader from "./HasBenefitsHeader";
import { SETTINGS_CUSTOMISE_BENEFITS } from "../../../routes/routeConfig";
var INITIAL_VARIABLES = {
    status: DealStatus.On,
    ignoreBlacklist: true,
    type: DealsListType.Company,
    sort: DealListSort.Date
};
var CompanyBenefitsList = /** @class */ (function (_super) {
    __extends(CompanyBenefitsList, _super);
    function CompanyBenefitsList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.popup = React.createRef();
        _this.state = {
            variables: INITIAL_VARIABLES,
            teams: []
        };
        _this.handleChange = function (benefit, action) {
            if (action === "remove") {
                return removeFromDealList(_this.state.variables, benefit);
            }
            return updateDealList(_this.state.variables, benefit);
        };
        _this.handleAdd = function () {
            if (_this.popup.current) {
                _this.popup.current.show();
                _this.popup.current.setEdit(false);
            }
        };
        _this.handleEdit = function (benefit) {
            if (_this.popup.current) {
                _this.popup.current.show();
                _this.popup.current.setBenefit(benefit);
            }
        };
        _this.handleNewPage = function (isVisible, apollo) {
            if (isVisible) {
                var _a = getDealList(apollo), results = _a.results, count = _a.count;
                var resultsLength = (results === null || results === void 0 ? void 0 : results.length) || 0;
                if (resultsLength && resultsLength !== count) { // has more
                    return apollo.nextPage(__assign(__assign({}, INITIAL_VARIABLES), { offset: resultsLength }));
                }
            }
        };
        _this.teamsForBenefit = function (benefit) {
            var teams = _this.state.teams.filter(function (t) { return benefit.teamIds.includes(t.uuid); });
            return teams.map(function (_a) {
                var public_name = _a.public_name;
                return public_name;
            }).join(", ");
        };
        return _this;
    }
    CompanyBenefitsList.prototype.componentDidMount = function () {
        var _this = this;
        teamService.list(authentication.userTenant().uuid).then(function (teams) {
            _this.setState({ teams: teams });
        });
    };
    CompanyBenefitsList.prototype.render = function () {
        var _this = this;
        var _a = this.props, minimalView = _a.minimalView, hideBannerImageUpload = _a.hideBannerImageUpload, handleBenefitChange = _a.handleBenefitChange;
        var Wrapper = minimalView ? Div : ShadowCard;
        var WrapperProps = minimalView ? null : { large: true, linkProps: { to: SETTINGS_CUSTOMISE_BENEFITS } };
        return (React.createElement(Wrapper, __assign({}, WrapperProps),
            React.createElement(DealList, { variables: this.state.variables }, function (apollo) {
                var dealsList = getDealList(apollo);
                var companyBenefits = dealsList.results;
                // call for tenantSetup, to enable/disable complete step button
                if (handleBenefitChange)
                    handleBenefitChange(companyBenefits);
                return (React.createElement(React.Fragment, null,
                    companyBenefits.length === 0 && (React.createElement(NoCompanyBenefits, { minimalView: !!minimalView, onAdd: _this.handleAdd })),
                    companyBenefits.length > 0 && (React.createElement(HasBenefitsHeader, { minimalView: !!minimalView, onAdd: _this.handleAdd, total: dealsList.count })),
                    companyBenefits.map(function (benefit) {
                        return React.createElement(Fragment, { key: benefit.uuid },
                            React.createElement(Flex, { justifyContent: "space-between", alignItems: "center", margin: "0 0 20px" },
                                React.createElement(Flex, { justifyContent: "flex-start", alignItems: "center" },
                                    React.createElement(Flex, { direction: "column" },
                                        React.createElement(BenefitHeader, null, benefit.header),
                                        benefit.teamIds.length > 0 &&
                                            React.createElement(Label2, null,
                                                React.createElement(FormattedMessage, { id: "admin.companyBenefits.list.selectTeam.label", values: { tooltip: React.createElement(IconTooltip, { icon: "i" }, _this.teamsForBenefit(benefit)) } })))),
                                React.createElement(CompanyBenefitsActions, { onChange: _this.handleChange, onBenefitEdit: _this.handleEdit, benefit: benefit })),
                            React.createElement(HR, null));
                    }),
                    React.createElement(LoadMore, { onVisible: function (isVisible) { return _this.handleNewPage(isVisible, apollo); } })));
            }),
            React.createElement(CompanyBenefitsPopup, { hideBannerImageUpload: hideBannerImageUpload, ref: this.popup, onChange: this.handleChange })));
    };
    CompanyBenefitsList.defaultProps = {
        minimalView: false
    };
    return CompanyBenefitsList;
}(Component));
export default CompanyBenefitsList;
